export default "__VITE_ASSET__DzOgMcjf__"